export default class PixInfo {
    constructor() { 
        this.dayOfMonth = 0
    }
}